import React from 'react';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, withPropsOnChange, branch, renderNothing, lifecycle } from 'recompose';

import SelectReader from './';
import { containerApp } from '../../../main';
import { createWebreaderTransaction } from '../payment/actions';
import { stripeConnectTokenAction } from '../../terminal/actions';
import { getReaderStage, getExternalPaymentInfo } from './selector';
import WebReaderLoader from '../../customer/tipping/components/WebReaderLoader';
import { setRefundData } from '../summary/actions';

const WebreaderProcessor = () => {
  return (
    <div>
      <SelectReader isProcessor />
      <WebReaderLoader isProcessor />
    </div>
  );
};

export default compose(
  branch(
    () => !containerApp || !containerApp.isActive(),
    renderNothing,
  ),
  connect(
    state => ({
      stage: getReaderStage(state),
      paymentInfo: getExternalPaymentInfo(state),
    }),
    dispatch => ({
      connectToTerminal: bindActionCreators(stripeConnectTokenAction, dispatch),
      charge: bindActionCreators(createWebreaderTransaction, dispatch),
      setRefundData: bindActionCreators(setRefundData, dispatch),
    }),
  ),
  withPropsOnChange(
    ['stage', 'paymentInfo'],
    (props) => {
      if (!props.stage && props.paymentInfo) {
        props.connectToTerminal(props.paymentInfo.strategy);
      }
    }
  ),
  withPropsOnChange(
    ['stage', 'paymentInfo'],
    (props) => {
      if (props.stage === 'connected' && props.paymentInfo) {
        const { strategy } = props.paymentInfo;

        if (strategy === 'pay') {
          const { paymentIntentSecret } = props.paymentInfo;
          props.charge({ paymentIntentSecret }, strategy);
        }

        if (strategy === 'refund') {
          const { chargeId, amount } = props.paymentInfo;
          props.setRefundData(null, { chargeId }, { amount }, noop);
          props.charge({ chargeId, amount }, strategy);
        }
      }
    }
  ),
  lifecycle({
    // color page background with white to fit native app's background
    componentWillMount() {
      document.documentElement.style.backgroundColor = '#fff';
    },
  }),
)(WebreaderProcessor);
